import { API } from '../helpers/fetcher'

export const swishAuthentication = async params =>
  API.post('v1/transaction/swish/authenticate', params)
